import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class TasksValidationModal extends Component {
  render() {
    const {tasksValidation} = this.props;

    if (!tasksValidation) {
      return null;
    }

    return (
      <Modal size='small' className='device-order-modal'
        open={tasksValidation.length > 0}>

        <Modal.Content scrolling>
          <Modal.Description>
            <div className='title-bar'>
              <h3>Los siguientes vehículos no fueron seleccionados para facturación anticipada
                debido a que incluyen un combo de accesorios que no tiene tareas de accesorización asignadas.</h3>
              <ul>
                {tasksValidation.map((validation, i) => {
                  return <li key={i}><b>{validation.chassis}</b></li>;
                })}
              </ul>
              <h3>El responsable de asignar las tareas a los combos de accesorios ya fue notificado.</h3>
            </div>
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button positive onClick={(e) => {
            e.preventDefault();
            this.props.restoreTasksValidationValue();
          }}>OK</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
  };
};

const {
  restoreTasksValidationValue,
} = Actions;

export default connect(mapStateToProps, {
  restoreTasksValidationValue,
})(TasksValidationModal);
